export var baseThemeStyleName = 'theme-base';
export var flagIconClassesPrefixName = 'flag-icon';
export var flagIconClassesPrefix = "".concat(flagIconClassesPrefixName, "-");
export var flagIconModulePath = 'node_modules/flag-icon-css';